/**
 * Why an agent run was FLAGged/FAILed, as the evaluator records it (#4966).
 * Mirrors functions-ai/src/agent-infra/evaluation/rubric.ts `UNVERIFIABLE_FLAG_REASONS`.
 */

/** Reasons meaning "our harness could not show the judge enough", not "the agent erred". */
const UNVERIFIABLE_REASONS: ReadonlySet<string> = new Set(["evidence_withheld", "no_tool_evidence"]);

/**
 * True when every recorded reason is an evidence gap, so the review says nothing about the
 * agent itself. Reviews written before #4966 carry no reasons and are never "unverifiable".
 */
export function isUnverifiableOnly(review: { flagReasons?: readonly string[] }): boolean {
  const reasons = review.flagReasons ?? [];
  return reasons.length > 0 && reasons.every((r) => UNVERIFIABLE_REASONS.has(r));
}
